import { format } from 'date-fns';
import { ChangeEvent, useMemo, useState } from 'react';

import { convertArrayToQueryString } from '../../Table/utils';
import { IDownloadModal } from './DownloadModal';

interface DateState {
  createdAtStart: string | null;
  createdAtEnd: string | null;
}
const useDownloadModal = ({ downloadOrders }: IDownloadModal) => {
  const [dates, setDates] = useState<DateState>({ createdAtStart: null, createdAtEnd: null });
  const [reportType, setReportType] = useState<string>('');
  const [fulfillmentStatus, setFulfillmentStatus] = useState<string[]>([]);

  const formatDate = (date: Date | null) => (date ? format(date, 'yyyy-MM-dd') : '');

  const handleFulfillmentStatus = (event: ChangeEvent<HTMLInputElement>) => {
    const currentValues = fulfillmentStatus || [];
    const newValue = currentValues?.includes(event.target.name)
      ? currentValues.filter((item) => item !== event.target.name)
      : [...currentValues, event.target.name];
    setFulfillmentStatus(newValue);
  };

  const download = () => {
    downloadOrders({
      filters: convertArrayToQueryString(fulfillmentStatus, 'fulfillmentStatus'),
      report_type: reportType,
      'filters[createdAtStart]': dates.createdAtStart!,
      'filters[createdAtEnd]': dates.createdAtEnd!,
    });
  };

  const handleReportType = (event: ChangeEvent<{ value: string }>) => {
    setReportType(event.target.value);
    if (event.target.value !== 'orders_list') {
      setFulfillmentStatus([]);
    }
  };

  const isDisabled = useMemo(() => {
    if (dates.createdAtStart && !dates.createdAtEnd) return true;
    if (!dates.createdAtStart && dates.createdAtEnd) return true;
    if (!reportType) return true;
    if (reportType === 'orders_list' && fulfillmentStatus.length === 0) return true;
    return false;
  }, [dates, reportType, fulfillmentStatus]);

  return {
    availableTypes,
    dates,
    setDates,
    reportType,
    handleReportType,
    setReportType,
    fulfillmentStatus,
    handleFulfillmentStatus,
    fulfillmentStatusOptions,
    formatDate,
    download,
    isDisabled,
  };
};

export default useDownloadModal;

const fulfillmentStatusOptions = [
  {
    label: 'Pendiente',
    value: 'pending',
  },
  {
    label: 'Enviada',
    value: 'fulfilled',
  },
  {
    label: 'Cancelada',
    value: 'canceled',
  },
];

const availableTypes = [
  {
    value: 'orders_list',
    label: 'Lista de órdenes',
  },
  {
    value: 'shipped_items',
    label: 'Productos entregados',
  },
  {
    value: 'serial_numbers',
    label: 'Números de serie',
  },
];
